export const getPlans = () => (dispatch) => {
  dispatch({
    type: 'GET_ALL_PLANS',
    payload: {
      endpoint: 'api/v1/plans',
      method: 'GET',
      delayLoad: 0,
    },
    components: ['plansLoader'],
  });
};

export const getBulkPlan =
  ({ quantity, onSuccess }) =>
  (dispatch) => {
    dispatch({
      type: 'GET_BULK_PLAN',
      payload: {
        endpoint: `api/v1/plans/bulk/${quantity}`,
        method: 'GET',
      },
      onSuccess: (data) => onSuccess(data),
    });
  };

export const getCheapestPlans = () => (dispatch) => {
  dispatch({
    type: 'GET_CHEAPEST_PLANS',
    payload: {
      endpoint: 'api/v1/plans/cheapest',
      method: 'GET',
      delayLoad: 0,
    },
    components: ['getCheapestPlansLoading'],
  });
};

export const getPhoneSearchProPlan = () => (dispatch) => {
  dispatch({
    type: 'GET_PHONE_SEARCH_PRO_PLAN',
    payload: {
      endpoint: 'api/v1/plans/phone-search-pro',
      method: 'GET',
    },
  });
};

export const getEmailVerificationCreditsPlan = () => (dispatch) => {
  dispatch({
    type: 'GET_EMAIL_VERIFICATION_CREDITS_PLAN',
    payload: {
      endpoint: 'api/v1/plans/email-verification-credits',
      method: 'GET',
      delayLoad: 0,
    },
    components: ['emailVerificationCreditsPlanLoader'],
  });
};

export const getPhoneNumbersCreditsPlan = () => (dispatch) => {
  dispatch({
    type: 'GET_PHONE_NUMBERS_CREDITS_PLAN',
    payload: {
      endpoint: 'api/v1/plans/phone-numbers-credits',
      method: 'GET',
      delayLoad: 0,
    },
    components: ['phoneNumbersCreditsPlanLoader'],
  });
};
